import { BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';

// Needed
export const history = createBrowserHistory();

export default ({ children }) => <Router history={history}>{children}</Router>;
